
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.532 68.019l3.759-2.758-3.296-3.296-42.96-42.96-3.296-3.296-2.758 3.759C7.765 25.214 5.231 32.303 5.231 40 5.23 59.203 20.797 74.77 40 74.77c7.697 0 14.786-2.535 20.532-6.751zm-41.196-55.94l-3.728 2.761 3.28 3.28L61.88 61.113l3.281 3.28 2.762-3.728c4.274-5.77 6.847-12.908 6.847-20.664C74.77 20.797 59.203 5.23 40 5.23c-7.756 0-14.894 2.574-20.664 6.848zM40 76C20.12 76 4 59.883 4 40S20.12 4 40 4c19.883 0 36 16.117 36 36S59.883 76 40 76z","stroke":"#DE3831","stroke-width":"8"}})])
          )
        }
      }
    